import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";

import { Observable } from "rxjs";

import { EndPointSignature } from "./end-point-signature.enum";

@Injectable()
export class EndPointService {
  // Inject HttpClient into your component or service.
  constructor(private http: HttpClient) {}

  service(signature: EndPointSignature, body: object | string, token?: string) {
    let data: Observable<Object>;
    switch (signature) {
      case EndPointSignature.ValidateToken:
        data = this.http.post(signature, body, {
          headers: new HttpHeaders().set("token", token),
          params: new HttpParams().set("pApplication", "prc"),
        });
        break;

      case EndPointSignature.AuthenticateUser:
        data = this.http.post(signature, body);
        break;

      case EndPointSignature.LogoutUser:
        data = this.http.post(signature, body, {
          headers: new HttpHeaders().set("token", token),
        });
        break;

      case EndPointSignature.UserActivate:
        data = this.http.put(signature, body, {
          params: new HttpParams().set("pToken", token),
        });
        break;

      case EndPointSignature.ResetPassword:
        data = this.http.put(signature, body);
        break;

      case EndPointSignature.ForgotPassword:
        data = this.http.put(signature, body, {
          headers: new HttpHeaders().set("Content-Type", "application/json"),
        });
        break;

      case EndPointSignature.ChangePassword:
        data = this.http.put(
          signature.replace("$userId", body["userId"]),
          {
            oldPassword: body["oldPassword"],
            newPassword: body["newPassword"],
          },
          {
            headers: new HttpHeaders().set("token", token),
          }
        );
        break;
    }
    return data;
  }
}
